<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="256"
  >
    <v-img
      v-if="environment"
      :src="environment.background"
      :position="environment.backgroundPosition"
      height="100%"
      class="pa-0"
    >
      <v-list
        v-if="environment"
        shaped
        dense
        class="ma-0 pa-0"
        height="100%"
      >
        <v-list-item
          :to="{name:'home'}"
          class="ma-0 mt-0 mb-2 pt-2"
        >
          <v-list-item-avatar color="white">
            <v-icon color="grey">
              mdi-arrow-left-circle
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-title class="title pt-2 pb-2">
            {{ environment.title }}
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <template
          v-for="(link, i) in environment.links"
        >
          <v-divider
            v-if="!link"
            :key="'divider-' + i"
            class="ma-0 mt-2 mb-2"
          />

          <v-menu
            :key="'menu-' + i"
            open-on-hover
            right
            offset-x
            :close-delay="50"
          >
            <template v-slot:activator="{ on }">
              <v-list-item
                v-if="link"
                :key="'item-' + i"
                :to="link.to"
                :exact="link.toExactRoute"
                active-class="info"
                class="ma-0 mt-2 mb-2"
                v-on="link.children && link.children.length && !$vuetify.breakpoint.xs ? on : undefined"
              >
                <v-list-item-action>
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title
                  v-text="link.text"
                />

                <v-list-item-action v-if="link.children && link.children.length && !$vuetify.breakpoint.xs">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
            <v-list
              v-if="link && link.children && link.children.length && !$vuetify.breakpoint.xs"
              dense
              dark
            >
              <v-subheader v-if="link.showHeader">
                <v-icon
                  large
                  left
                  v-text="link.icon"
                />
                <span class="title font-weight-bold d-inline-block ml-4">{{ link.text }}</span>
              </v-subheader>
              <v-divider v-if="link.showHeader" />
              <v-list-item
                v-for="(children, ci) in link.children"
                :key="'menu-' + i + '-' + ci"
                :to="children.to"
                :exact="children.toExactRoute"
                active-class="info"
              >
                <v-list-item-action>
                  <v-icon v-text="children.icon" />
                </v-list-item-action>
                <v-list-item-title v-text="children.text" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-list>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapGetters, mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapGetters('user', ['hasOneOfPermissions']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    environment () {
      let pathSplitted = this.$route.fullPath.split('/')
      let home = 'home'
      let currentEnvironment = home
      if (pathSplitted.length > 1) {
        currentEnvironment = pathSplitted[1] === '' || !pathSplitted[1] ? home : pathSplitted[1]
      }
      return this.environments[currentEnvironment]
    },
    environments () {
      return {
        home: {
          title: 'WorkTools',
          links: []
        },
        config: {
          title: 'Configuration',
          background: '/img/config-background.jpg',
          backgroundPosition: 'center center',
          links: [
            {
              to: { name: 'config-home' },
              icon: 'mdi-view-dashboard',
              text: 'Tableau de bord',
              toExactRoute: true
            },
            {
              to: { name: 'config-client-list' },
              icon: 'mdi-folder-account',
              text: 'Fiche clients',
              credentials: ['ROLE_CONFIG_CLIENT_SHOW']
            },
            {
              to: { name: 'config-tarif-horaire-list' },
              icon: 'mdi-currency-eur',
              text: 'Tarif horaire',
              credentials: ['ROLE_CONFIG_TARIF_HORAIRE_SHOW']
            }
          ]
        },
        temps: {
          title: 'Temps de travail',
          background: '/img/temps-background.jpeg',
          backgroundPosition: 'center center',
          links: [
            {
              to: { name: 'temps-home' },
              icon: 'mdi-timer',
              text: 'Tableau de bord',
              toExactRoute: true
            },
            {
              to: { name: 'temps-saisie' },
              icon: 'mdi-calendar-clock',
              text: 'Saisie des temps',
              credentials: ['ROLE_TEMPS_SAISIE_EDIT']
            },
            {
              to: { name: 'temps-synthese' },
              icon: 'mdi-chart-pie',
              text: 'Synthèse',
              credentials: ['ROLE_TEMPS_SYNTHESE_SHOW']
            }
          ]
        }
      }
    }
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer'])
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }

    .v-list {
      background-color: rgba(27,27,27,0.6) !important;
    }
  }
</style>
